<template>
  <div class="telas-user">
    <dash-header :pages="breadCrumbsPages" :dashboardTitle="dashboardTitle"/>
    <a-layout id="components-layout-demo-custom-trigger">
      <dash-sidebar
      defaultSelectedKeys="2"
      :menuItems="commonMenuItems.admin"
      v-if="userRole === 'telas_telas_administrator'"/>
      <dash-sidebar
      defaultSelectedKeys="3"
      :menuItems="commonMenuItems.courseSubmitters"
      v-if="userRole === 'telas_course_submitters'"/>
      <a-layout>
        <a-layout-content
          :style="{ margin: '24px 16px', padding: '24px', background: '#fff', minHeight: '280px' }"
        >
        <course-submitter-user-list v-if="userRole === 'telas_course_submitters'"/>
        <telas-admin-user-list v-if="userRole === 'telas_telas_administrator'"/>
        </a-layout-content>
      </a-layout>
    </a-layout>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import telasAdminUserList from '@src/components/dashboard/admin/User-tab.vue';
import courseSubmitterUserList from '@src/components/dashboard/course-submitter/User-tab.vue';
import dashSidebar from './Sidebar.vue';
import dashHeader from './Header.vue';

export default {
  name: 'telas-user',
  components: {
    dashSidebar,
    dashHeader,
    courseSubmitterUserList,
    telasAdminUserList,
  },
  computed: {
    ...mapGetters('dashboard', {
      userDetails: 'getUserProfileDetails',
    }),
    ...mapState('user', {
      userID: state => state.userDetails.user_id,
    }),
    ...mapGetters('user', {
      userToken: 'getUserToken',
    }),
    ...mapGetters('user', {
      userRole: 'getUserRole',
    }),
  },
  data() {
    return {
      breadCrumbsPages: [
        {
          name: 'Home',
          route: '/',
        },
        {
          name: 'Dashboard',
          route: '/dashboard',
        },
        {
          name: 'User List',
          route: '/dashboard/telas-user',
        },
      ],
      dashboardTitle: '',
    };
  },
  watch: {
    userDetails(val) {
      const userRoleStringArray = val.user_role.split('_');
      userRoleStringArray.shift();
      const userRole = userRoleStringArray.join(' ');
      this.dashboardTitle = `${userRole} Dashboard`;
    },
  },
  methods: {
    ...mapActions('dashboard', {
      getUserDetail: 'getUserDetail',
    }),
  },
  created() {
  },
  mounted() {
  },
};
</script>
